import React from 'react';
import { Button, Container, Text } from '@groupelacentrale/contact-storybook';
import './ConfirmationPage.scss';

interface Props {
  onGoToAccount: () => void | undefined;
  onNewDeposit: () => void | undefined;
}

export const ConfirmationPageView: React.FC<Props> = ({ onGoToAccount, onNewDeposit }) => {
  return (
    <Container shadowed paddings="mediumP" className="confirmation-container" backgroundColor="bgWhite">
      <Text weight="bold">
        Merci, votre annonce a bien &eacute;t&eacute; enregistr&eacute;e et est d&eacute;sormais visible sur le site et
        sur votre vitrine.
      </Text>
      <div className="actions">
        <Button onClick={onGoToAccount} theme="quaternary" label="Retour à mon compte">
          Retour &agrav; mon compte
        </Button>
        <Button onClick={onNewDeposit} theme="secondary" label="Déposer une autre annonce" />
      </div>
    </Container>
  );
};
